import styles from "./OnboardingHeadingCard.module.css";

interface OnboardingHeadingCardProps {
	text: string;
}

export function OnboardingHeadingCard({ text }: OnboardingHeadingCardProps) {
	return (
		<div className={styles.container}>
			<div className={styles.card}>
				<h1 className={styles.text}>{text}</h1>
			</div>
		</div>
	);
}
